export default "__VITE_ASSET__8e9790d0__"